import { useLocale } from "../lib/i18n";

export function Footer() {
  const { t } = useLocale();
  return (
    <div className="container" style={{ paddingTop: 26 }}>
      <div className="divider" />
      <div style={{ paddingTop: 14 }} className="row">
        <div className="p" style={{ fontSize: 12 }}>
          © {new Date().getFullYear()} Akhirah Projects • {t.footerLong}
        </div>
      </div>
    </div>
  );
}
